import { createPrefetchApi } from '@RootCommon/api/apiPrefetcher'
import { getI18nWebParamsApi } from './i18nApi'
import { getAccountShopListApi, getShowImMsgBoxApi } from './shopInfoApi'
import { getRbacAuthResourceApi } from './account'

const CACHE_KEYS = {
  getAccountShopListPApi: Symbol('getAccountShopListPApi'),
  getI18nWebParamsPApi: Symbol('getI18nWebParamsPApi'), // 唯一标识符
  getRbacAuthResourceApi: Symbol('getRbacAuthResourceApi'), // 唯一标识符
  getShowImMsgBoxApi: Symbol('getShowImMsgBoxApi'), // 唯一标识符
}

// 创建支持参数的缓存函数，不同参数使用不同的缓存键
const createPrefetchApiWithParams = (baseCacheKey: string, requestFn: (params?: any) => Promise<any>, cacheTime = 0) =>
  (params?: any) => {
    // 将参数序列化后作为缓存键的一部分，确保不同参数使用不同缓存
    const paramsKey = params ? JSON.stringify(params) : 'no-params'
    const cacheKey = Symbol(`${baseCacheKey}_${paramsKey}`)
    return createPrefetchApi(cacheKey, requestFn, cacheTime)(params)
  }

// 获取账号下门店列表预请求
export async function getAccountShopListPApi (params) {
  return createPrefetchApi(CACHE_KEYS.getAccountShopListPApi, getAccountShopListApi, 4 * 1000)(params)
}

// 获取i18n语言信息预请求
export async function getI18nWebParamsPApi (params?) {
  return createPrefetchApi(CACHE_KEYS.getI18nWebParamsPApi, getI18nWebParamsApi, 4 * 1000)(params)
}

// 获取权限资源信息预请求（支持不同参数的独立缓存）
export const getRbacAuthResourcePApi = createPrefetchApiWithParams('getRbacAuthResourceApi', getRbacAuthResourceApi, 4 * 1000)

// 获取i18n语言信息预请求
export async function getShowImMsgBoxPApi (params?) {
  return createPrefetchApi(CACHE_KEYS.getShowImMsgBoxApi, getShowImMsgBoxApi, 10 * 1000)(params)
}
